import { T } from "./Translate";
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, {
  useEffect,
  useLayoutEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import useInfiniteScroll, { FEED_PAGE_SIZE } from "../hooks/useInfiniteScroll";
import { usePagedFeed, useEnsureFeedCount, feedMayHaveMore } from "../hooks/usePagedFeed";
import {
  Container,
  AppBar,
  Toolbar,
  CardMedia,
  IconButton,
  Box,
  Typography,
  Button,
  List,
  ListItem,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Avatar,
  AvatarGroup,
  TextField,
  Paper,
  Skeleton,
  Menu,
  MenuItem,
  Drawer,
  Checkbox,
  FormControlLabel,
  Select,
  InputLabel,
  FormControl,
  useMediaQuery,
  Chip,
  Alert,
} from "@mui/material";
import { Search as SearchIcon } from "../icons";
import { Share as ShareIcon } from "../icons";
import { Bookmark as BookmarkIcon } from "../icons";
import { BookmarkBorder as BookmarkBorderIcon } from "../icons";
import { MoreVert as MoreVertIcon } from "../icons";
import { Star as StarIcon } from "../icons";
import { ExpandMore as ExpandMoreIcon } from "../icons";
import { ExpandLess as ExpandLessIcon } from "../icons";
import { ForumOutlined as ForumOutlinedIcon } from "../icons";
import { Send as SendIcon } from "../icons";
import "react-calendar/dist/Calendar.css";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { isLoggedIn } from "../session";
import { auth, db } from "../firebase";
import logoSvg from "../imgs/logo.png";
import { barColors, brandColors } from "../theme";
import { alpha } from "@mui/material/styles";
import InterestButton from "../components/InterestButton";
import themeService from "../services/themeService";
import { ArrowBackIos as ArrowBackIosIcon } from "../icons";
import { ArrowForwardIos as ArrowForwardIosIcon } from "../icons";
import ScrollAwareVideo from "../components/ScrollAwareVideo";
import BottomToolbar from "./BottomToolbar";
import { doc, getDoc } from "firebase/firestore";
import { useGeolocation } from "../hooks/useGeolocation";
import {
  formatDate,
  fetchFollowing,
  fetchAttendees,
  handleAttend,
  handleFollow,
  handleMeInteresaEvent,
  fetchUserEventLikes,
  getHorarioLabel,
  postEventQuestion,
  postEventAnswer,
  fetchEventQuestionsAndAnswersWithUserData,
  toggleSaveEvent,
  fetchSavedEventIds,
  hideEvent,
  fetchHiddenEventIds,
  PUBLIC_EVENTS_FILTER,
  useMyPrivateEvents,
  mergeEventsByCreatedAt,
  sellsTicketsWithPaypal,
} from "./eventsUtils";
import {
  recordTicketSale,
  getPendingEventCommission,
  markEventCommissionPaid,
  EVENT_COMMISSION_RATE,
  getEventDates,
  getNextEventDate,
  formatEventDatesList,
} from "./eventsUtils";
import CopyToClipboardComponent from "./CopyToClipboardButton";
import EventCountdown from "../components/EventCountdown";
import FollowItemButton from "../components/FollowItemButton";
import { getCountryFromCoordinates, formatCount, reportItem, unfollowCompany, fetchVerifiedUids, fetchOfficialUids } from "./homeUtils";
import VerifiedBadge from "./VerifiedBadge";
import OfficialBadge from "./OfficialBadge";
import useAuthorPhotos from "./useAuthorPhotos";
import CustomToolbar from "./CustomToolbar";
import { Event as EventIcon } from "../icons";
import { Close as CloseIcon } from "../icons";
import AttendeesDialog from "./AttendeesDialog";
import { blockUser, unblockUser, fetchBlockedIds } from "../utils/blockedUsers";
import { pageContentSx, PAGE_CONTENT_MAX_WIDTH, FILTER_PANEL_BOTTOM_GAP, filterPanelScrollSx, feedPostSx, feedPostHeaderSx, feedPostBodySx, feedPostMediaRadius, feedPostTextPx } from "../pageLayout";
import { useDesktopSidebar } from "../desktopSidebarContext";
import PaypalButton from "../components/PaypalButton";
import { Lock as LockIcon } from "../icons";
import SheetDragHandle from "../components/SheetDragHandle";
import { safeHttpUrl } from "../utils/safeUrl";

import SearchClearAdornment from "../components/SearchClearAdornment";
// Ver mismo criterio en home.js: logo.png (texto blanco, fondo navy sólido)
// queda invisible en Modo Claro, donde el AppBar pasa a blanco — se usa la
// versión con texto oscuro (public/logo1.png) en ese caso.
const LIGHT_LOGO_URL = `${process.env.PUBLIC_URL}/logo1.png`;
const DARK_LOGO_URL = `${process.env.PUBLIC_URL}/logo5.png`;
const isLightTheme = themeService.getResolvedMode() === "light";
const isDarkTheme = themeService.getResolvedMode() === "dark";

const Events = () => {
  const [loading, setLoading] = useState(false);
  // Eventos de a tandas desde Firestore (ver usePagedFeed): antes se
  // escuchaba la colección entera. Filtros y orden se aplican sobre lo cargado.
  // Solo públicos (las reglas no dejan listar privados ajenos); los privados
  // donde participa el usuario llegan aparte y se mezclan por fecha.
  const eventsFeed = usePagedFeed("events", undefined, undefined, PUBLIC_EVENTS_FILTER);
  const myPrivateEvents = useMyPrivateEvents();
  const events = useMemo(
    () => mergeEventsByCreatedAt(myPrivateEvents, eventsFeed.items),
    [myPrivateEvents, eventsFeed.items]
  );
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [following, setFollowing] = useState([]);
  const [attendees, setAttendees] = useState({});
  const [attendeeProfiles, setAttendeeProfiles] = useState({});
  const [openImageModal, setOpenImageModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [modalImages, setModalImages] = useState([]);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const searchTimeout = useRef(null);
  // Eventos con un toggle de "Me interesa" en curso (mismo criterio que
  // pendingLikeOfferIds en home.js): evita doble click/tap duplicando la
  // transacción de handleMeInteresaEvent.
  const pendingLikeEventIds = useRef(new Set());
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [highlightedEventId, setHighlightedEventId] = useState(null);
  const appBarRef = useRef(null);
  const [appBarHeight, setAppBarHeight] = useState(144);
  const [searchBarHidden, setSearchBarHidden] = useState(false);
  const lastScrollY = useRef(0);
  const [aspectRatio, setAspectRatio] = useState("9:16");
  const [userProfiles, setUserProfiles] = useState({});
  const [isLoadingAttendees, setIsLoadingAttendees] = useState(false);
  const [openAttendeesDialog, setOpenAttendeesDialog] = useState(false);
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [blockedIds, setBlockedIds] = useState([]);
  const [verifiedUids, setVerifiedUids] = useState([]);
  const [officialUids, setOfficialUids] = useState([]);
  const [optionsMenuAnchorEl, setOptionsMenuAnchorEl] = useState(null);
  const [optionsMenuEvent, setOptionsMenuEvent] = useState(null);
  const [userLikes, setUserLikes] = useState({});
  // Mismo criterio que home.js: el feed (980) queda centrado en la página
  // de verdad, con una columna espejo invisible del otro lado para
  // compensar la sidebar (260+24) — hace falta 1568px + padding lateral.
  const sidebarActive = useDesktopSidebar();
  // Con la sidebar de escritorio (240px) el layout ancho necesita ese lugar de más.
  const isDesktop = useMediaQuery(sidebarActive ? '(min-width:1840px)' : '(min-width:1600px)');
  // Con la sidebar el logo y las categorías viven en ella: el AppBar solo
  // queda (plano) para los íconos de buscar/filtros cuando no hay panel lateral.
  const showTopBar = !sidebarActive || !isDesktop;

  // Mide el alto real del AppBar fijo en vez de adivinar un valor en px: así
  // el contenido de abajo arranca pegado sin gap ni superposición (ver mismo
  // criterio en home.js).
  useLayoutEffect(() => {
    const node = appBarRef.current;
    if (!node) {
      setAppBarHeight(0);
      return;
    }
    const updateHeight = () => setAppBarHeight(node.offsetHeight);
    updateHeight();
    const observer = new ResizeObserver(updateHeight);
    observer.observe(node);
    return () => observer.disconnect();
  }, [isDesktop, isSearchOpen, showTopBar]);

  // Mismo criterio que home.js: oculta la barra de búsqueda/filtro al
  // scrollear hacia abajo y la muestra de nuevo al subir; no se oculta con
  // el buscador abierto para no perder el foco a mitad de una búsqueda.
  useEffect(() => {
    if (isDesktop) return undefined;
    const handleScroll = () => {
      const currentY = window.scrollY;
      if (isSearchOpen) {
        setSearchBarHidden(false);
      } else if (currentY > lastScrollY.current && currentY > 80) {
        setSearchBarHidden(true);
      } else {
        setSearchBarHidden(false);
      }
      lastScrollY.current = currentY;
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isDesktop, isSearchOpen]);

  const [filtersOpen, setFiltersOpen] = useState(false);
  const [sortBy, setSortBy] = useState("proximos");
  const [filterEventType, setFilterEventType] = useState("");
  const [filterFollowedOnly, setFilterFollowedOnly] = useState(false);
  const [filterFreeOnly, setFilterFreeOnly] = useState(false);
  const [filterAttendingOnly, setFilterAttendingOnly] = useState(false);
  const [dateRange, setDateRange] = useState({ from: "", to: "" });
  const [detectedCountry, setDetectedCountry] = useState(null);
  const { position: geoPosition } = useGeolocation();
  const [eventQuestionsAndAnswers, setEventQuestionsAndAnswers] = useState({});
  const [newEventQuestion, setNewEventQuestion] = useState({});
  const [newEventAnswer, setNewEventAnswer] = useState({});
  const [showMoreEventQuestions, setShowMoreEventQuestions] = useState({});
  const [showEventQA, setShowEventQA] = useState({});
  const [savedEventIds, setSavedEventIds] = useState([]);
  const [hiddenEventIds, setHiddenEventIds] = useState([]);
  const [purchasingEventId, setPurchasingEventId] = useState(null);
  const [pendingEventCommissions, setPendingEventCommissions] = useState({});
  const [commissionFeedback, setCommissionFeedback] = useState({});

  // Comisión pendiente de los propios eventos pagos (ver EVENT_COMMISSION_RATE
  // en eventsUtils.js), mismo criterio que StoreDashboardTab.js para tiendas.
  useEffect(() => {
    if (!auth.currentUser) return;
    const ownPaidEvents = events.filter(
      (event) => event.uid === auth.currentUser.uid && event.isPaid
    );
    ownPaidEvents.forEach(async (event) => {
      const result = await getPendingEventCommission(event.id, auth.currentUser.uid);
      setPendingEventCommissions((prev) => ({ ...prev, [event.id]: result }));
    });
  }, [events]);

  // Deep link desde otras pantallas (ej. members.js) a un evento puntual:
  // /events?highlight=<eventId> scrollea hasta esa card y la resalta un
  // momento para que se note cuál es.
  useEffect(() => {
    const highlight = searchParams.get("highlight");
    if (!highlight || eventsFeed.loading || events.length === 0) return;
    const target = document.getElementById(`event-${highlight}`);
    if (!target) return;
    target.scrollIntoView({ behavior: "smooth", block: "center" });
    setHighlightedEventId(highlight);
    const timeout = setTimeout(() => setHighlightedEventId(null), 2500);
    return () => clearTimeout(timeout);
  }, [searchParams, eventsFeed.loading, events]);

  const handleTicketPurchaseApproved = useCallback(
    async (eventItem, details) => {
      try {
        await recordTicketSale({
          eventId: eventItem.id,
          sellerId: eventItem.uid,
          buyerId: auth.currentUser.uid,
          buyerEmail: details.payer?.email_address,
          amount: eventItem.ticketPrice,
          paypalTransactionId: details.id,
        });
        setPurchasingEventId(null);
        fetchAttendees(events, setAttendees, setAttendeeProfiles);
      } catch (error) {
        console.error("Error al registrar la compra de la entrada:", error);
      }
    },
    [events]
  );

  const handleEventCommissionApproved = useCallback(
    async (eventItem, details) => {
      const amount = pendingEventCommissions[eventItem.id]?.amount || 0;
      await markEventCommissionPaid({
        eventId: eventItem.id,
        sellerId: auth.currentUser.uid,
        amount,
        paypalTransactionId: details.id,
      });
      setCommissionFeedback((prev) => ({
        ...prev,
        [eventItem.id]: { type: "success", message: "Comisión pagada correctamente." },
      }));
      const result = await getPendingEventCommission(eventItem.id, auth.currentUser.uid);
      setPendingEventCommissions((prev) => ({ ...prev, [eventItem.id]: result }));
    },
    [pendingEventCommissions]
  );

  const handleMeInteresaClick = useCallback(async (eventId) => {
    if (pendingLikeEventIds.current.has(eventId)) return;
    pendingLikeEventIds.current.add(eventId);
    try {
      await handleMeInteresaEvent(eventId, !!auth.currentUser, auth.currentUser?.uid, setUserLikes);
    } finally {
      pendingLikeEventIds.current.delete(eventId);
    }
  }, []);

  useEffect(() => {
    if (geoPosition?.latitude && geoPosition?.longitude) {
      getCountryFromCoordinates(geoPosition.latitude, geoPosition.longitude).then(
        setDetectedCountry
      );
    }
  }, [geoPosition]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        fetchBlockedIds(user.uid).then(setBlockedIds);
        fetchUserEventLikes(true, setUserLikes);
        fetchSavedEventIds(user.uid).then(setSavedEventIds);
        fetchHiddenEventIds(user.uid).then(setHiddenEventIds);
        fetchVerifiedUids().then(setVerifiedUids);
        fetchOfficialUids().then(setOfficialUids);
      } else {
        setBlockedIds([]);
        setUserLikes({});
        setSavedEventIds([]);
        setHiddenEventIds([]);
      }
    });

    return unsubscribe;
  }, []);

  const handleOpenOptionsMenu = useCallback((event, eventData) => {
    setOptionsMenuAnchorEl(event.currentTarget);
    setOptionsMenuEvent(eventData);
  }, []);

  const handleOptionsMenuClose = useCallback(() => {
    setOptionsMenuAnchorEl(null);
    setOptionsMenuEvent(null);
  }, []);

  const handleUnfollowMenuClick = useCallback((eventItem) => {
    if (!eventItem || !auth.currentUser) return;
    unfollowCompany(eventItem.uid, auth.currentUser.uid, setFollowing);
  }, []);

  const handleToggleSaveEventClick = useCallback((eventItem) => {
    if (!eventItem || !auth.currentUser) return;
    const isSaved = savedEventIds.includes(eventItem.id);
    toggleSaveEvent(auth.currentUser.uid, eventItem.id, isSaved);
    setSavedEventIds((prev) =>
      isSaved ? prev.filter((id) => id !== eventItem.id) : [...prev, eventItem.id]
    );
  }, [savedEventIds]);

  const handleReportEvent = useCallback((eventItem) => {
    if (!eventItem || !auth.currentUser) return;
    reportItem({
      reporterId: auth.currentUser.uid,
      targetType: "event",
      targetId: eventItem.id,
      companyId: eventItem.uid,
    });
  }, []);

  const handleHideEvent = useCallback((eventItem) => {
    if (!eventItem || !auth.currentUser) return;
    hideEvent(auth.currentUser.uid, eventItem.id);
    setHiddenEventIds((prev) => (prev.includes(eventItem.id) ? prev : [...prev, eventItem.id]));
  }, []);

  const handleSimilarEvents = useCallback((eventItem) => {
    if (!eventItem) return;
    setFilterEventType(eventItem.eventType || "");
  }, []);

  const handleBlockUserClick = useCallback(async (eventData) => {
    if (!eventData || !auth.currentUser) return;
    await blockUser(auth.currentUser.uid, eventData.uid);
    setBlockedIds((prev) =>
      prev.includes(eventData.uid) ? prev : [...prev, eventData.uid]
    );
  }, []);

  const handleUnblockUserClick = useCallback(async (eventData) => {
    if (!eventData || !auth.currentUser) return;
    await unblockUser(auth.currentUser.uid, eventData.uid);
    setBlockedIds((prev) => prev.filter((id) => id !== eventData.uid));
  }, []);

  const handleOpenAttendeesDialog = async (eventId) => {
    setSelectedEventId(eventId);
    setOpenAttendeesDialog(true);
    setIsLoadingAttendees(true);

    if (attendees[eventId]?.length > 0) {
      await fetchUserProfiles(attendees[eventId]);
    }

    setIsLoadingAttendees(false);
  };

  const fetchUserProfiles = async (attendeeIds) => {
    try {
      const profiles = { ...userProfiles };
      const newAttendeeIds = attendeeIds.filter((id) => !profiles[id]);

      await Promise.all(
        newAttendeeIds.map(async (attendeeId) => {
          const userDocRef = doc(db, "users", attendeeId);
          const userDocSnap = await getDoc(userDocRef);

          if (userDocSnap.exists()) {
            const userData = userDocSnap.data();
            profiles[attendeeId] = {
              id: attendeeId,
              name: userData.name || userData.displayName || "Usuario",
              profileImageUrl: userData.profileImageUrl || "",
              email: userData.email || "",
            };
          }
        })
      );

      setUserProfiles(profiles);
      return profiles;
    } catch (error) {
      console.error("Error fetching user profiles:", error);
      return {};
    }
  };

  const handleLoadedMetadata = (e) => {
    const video = e.target;
    const ratio = video.videoWidth / video.videoHeight;
    setAspectRatio(ratio > 1 ? "16:9" : "9:16");
  };


  useEffect(() => {
    if (!isLoggedIn()) {
      navigate("/login");
    }
  }, [navigate]);

  useEffect(() => {
    if (events.length === 0) return;
    events.forEach((event) => {
      if (!eventQuestionsAndAnswers[event.id]) {
        fetchEventQuestionsAndAnswersWithUserData(event.id, (fetchedData) => {
          setEventQuestionsAndAnswers((prevData) => ({
            ...prevData,
            [event.id]: fetchedData,
          }));
        });
      }
    });
  }, [events]);

  const handleEventQuestionSubmit = async (eventId) => {
    const questionText = newEventQuestion[eventId]?.trim();
    if (questionText && auth.currentUser) {
      await postEventQuestion(eventId, auth.currentUser.uid, questionText);
      setNewEventQuestion((prev) => ({ ...prev, [eventId]: "" }));
    }
  };

  const handleEventAnswerSubmit = async (questionId, eventId) => {
    const answerText = newEventAnswer[questionId]?.trim();
    if (answerText && auth.currentUser) {
      await postEventAnswer(questionId, auth.currentUser.uid, answerText, eventId);
      setNewEventAnswer((prev) => ({ ...prev, [questionId]: "" }));
    }
  };

  useEffect(() => {
    fetchFollowing(setFollowing, setLoading);
  }, []);

  useEffect(() => {
    fetchAttendees(events, setAttendees, setAttendeeProfiles);
  }, [events]);

  const handleCloseAttendeesDialog = useCallback(() => {
    setOpenAttendeesDialog(false);
    setSelectedEventId(null);
  }, []);

  const handleAttendeeClick = useCallback(
    (attendeeId) => {
      navigate(`/profile/${attendeeId}`);
      handleCloseAttendeesDialog();
    },
    [navigate]
  );

  const handleAttendEvent = useCallback(
    async (eventId) => {
      await handleAttend(eventId);
      fetchAttendees(events, setAttendees, setAttendeeProfiles);
    },
    [events]
  );

  const handleFollowCompany = useCallback(
    async (companyId) => {
      await handleFollow(companyId, following, setFollowing, setLoading);
    },
    [following]
  );

  const handleOpenImageModal = useCallback((images) => {
    setModalImages(images);
    setOpenImageModal(true);
  }, []);

  const handleCloseImageModal = useCallback(() => {
    setOpenImageModal(false);
  }, []);

  const handleNextImage = useCallback(() => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === modalImages.length - 1 ? 0 : prevIndex + 1
    );
  }, [modalImages.length]);

  const handlePreviousImage = useCallback(() => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? modalImages.length - 1 : prevIndex - 1
    );
  }, [modalImages.length]);

  const handleClickPerfil = useCallback(
    (event) => {
      if (event) {
        navigate(`/profile/${event.uid}`);
      }
    },
    [navigate]
  );

  const isCompanyFollowed = useCallback(
    (companyId) => following.includes(companyId),
    [following]
  );

  const handleSearch = useCallback(
    (term) => {
      if (!Array.isArray(events)) {
        console.error("events is not an array:", events);
        return;
      }
      const searchValue = term.toLowerCase().trim();
      const filteredResults = events.filter(
        (event) =>
          event.name.toLowerCase().includes(searchValue) ||
          (event.title && event.title.toLowerCase().includes(searchValue))
      );
      setFilteredEvents(filteredResults);
      setHasSearched(searchValue.length > 0);
    },
    [events]
  );

  // Las tandas nuevas de eventos también tienen que pasar por la búsqueda.
  useEffect(() => {
    if (searchTerm.trim()) handleSearch(searchTerm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events]);

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      handleSearch(value);
    }, 300);
  };

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
    if (!isSearchOpen) {
      setTimeout(() => {
        document.getElementById("search-input")?.focus();
      }, 100);
    } else {
      setSearchTerm("");
      handleSearch("");
      setHasSearched(false);
    }
  };

  const styles = {
    root: {
      backgroundColor: "#f5f7fa",
      minHeight: "100vh",
      paddingBottom: "80px",
    },

   topAppBar: {
      backgroundColor: barColors.background,
      boxShadow: "none",
    },
    logoToolbar: {
      display: "flex",
      justifyContent: "center",
      padding: "8px 0",
    },
    media: {
      width: "130px",
      height: "auto",
      aspectRatio: "847 / 231",
    },

    listItem: {
      display: "block",
      width: "100%",
      border: `1px solid ${brandColors.divider}`,
      backgroundColor: brandColors.backgroundPaper,
      borderRadius: "8px",
      boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
      transition: "transform 0.2s ease, box-shadow 0.2s ease",
      overflow: "hidden",
      "&:hover": {
        boxShadow: "0 3px 8px rgba(0,0,0,0.4)",
      },
    },

    contUser: {
      display: "flex",
      alignItems: "center",
      padding: "12px 16px",
      borderBottom: `1px solid ${brandColors.divider}`,
      backgroundColor: brandColors.backgroundDefault,
    },
    name: {
      color: brandColors.accent,
      fontSize: "1rem",
      fontWeight: "600",
      textDecoration: "none",
      cursor: "pointer",
      transition: "color 0.2s ease",
      "&:hover": {
        opacity: 0.8,
      },
    },

    eventContent: {
      padding: "0 16px",
    },
    title: {
      color: brandColors.textPrimary,
      fontSize: "1.1rem",
      fontWeight: "600",
      marginBottom: "8px",
      lineHeight: 1.3,
    },
    description: {
      color: brandColors.textSecondary,
      fontSize: "0.9rem",
      fontWeight: "400",
      lineHeight: 1.5,
      marginBottom: "12px",
    },
    event: {
      display: "flex",
      alignItems: "center",
      width: "100%",
      boxSizing: "border-box",
      gap: "8px",
      fontSize: "0.9rem",
      fontWeight: "500",
      color: brandColors.accent,
      marginBottom: "12px",
      padding: "8px 12px",
      backgroundColor: brandColors.backgroundDefault,
      borderRadius: "8px",
    },
    date: {
      display: "flex",
      alignItems: "center",
      width: "100%",
      boxSizing: "border-box",
      gap: "8px",
      color: brandColors.accent,
      fontSize: "0.9rem",
      fontWeight: "500",
      marginBottom: "16px",
      padding: "8px 12px",
      backgroundColor: brandColors.backgroundDefault,
      borderRadius: "8px",
    },
    created: {
      color: brandColors.textSecondary,
      fontSize: "0.75rem",
      marginTop: "12px",
      marginBottom: "16px",
    },

    mediaContainer: {
      position: "relative",
      width: "100%",
      borderRadius: "12px",
      overflow: "hidden",
      backgroundColor: "#111",
      marginBottom: "16px",
    },
    imageContainer: {
      position: "relative",
      width: "100%",
      borderRadius: "6px",
      overflow: "hidden",
      backgroundColor: brandColors.backgroundDefault,
    },
    // Como en Instagram, el alto lo pone la imagen (sin recuadro gris arriba
    // y abajo de un flyer horizontal), con tope de 4:5 para los muy verticales.
    mainImage: {
      display: "block",
      width: "100%",
      height: "auto",
      maxHeight: "min(125vw, 560px)",
      objectFit: "contain",
      transition: "transform 0.3s ease",
      backgroundColor: brandColors.backgroundDefault,
      "&:hover": {
        transform: "scale(1.02)",
      },
    },
    additionalImagesOverlay: {
      position: "absolute",
      bottom: "12px",
      right: "12px",
      backgroundColor: "rgba(0,0,0,0.75)",
      color: "white",
      padding: "8px 12px",
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      cursor: "pointer",
      transition: "background-color 0.2s ease",
      "&:hover": {
        backgroundColor: "rgba(0,0,0,0.9)",
      },
    },

    actionButton: {
      textTransform: "none",
      borderRadius: "6px",
      padding: "8px 14px",
      fontWeight: "500",
      fontSize: "0.9rem",
      border: `1px solid ${brandColors.primary}`,
      color: brandColors.accent,
      transition: "background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease",
    },
    attendeesContainer: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginBottom: "16px",
      padding: "12px",
      backgroundColor: "#1a1a2e",
      borderRadius: "8px",
    },
    attendeeAvatar: {
      width: 32,
      height: 32,
      border: "2px solid rgba(255,255,255,0.3)",
      transition: "transform 0.2s ease",
      "&:hover": {
        transform: "scale(1.1)",
      },
    },
    attendeeCount: {
      color: "rgba(255,255,255,0.6)",
      fontSize: "14px",
      fontWeight: "500",
    },

    imageModal: {
      backgroundColor: "rgba(0,0,0,0.9)",
    },
    imageModalContent: {
      maxWidth: "95%",
      maxHeight: "90vh",
      position: "relative",
      padding: "20px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    modalImage: {
      maxWidth: "100%",
      maxHeight: "80vh",
      borderRadius: "8px",
      objectFit: "contain",
    },
    navigationButton: {
      position: "absolute",
      backgroundColor: "rgba(255,255,255,0.1)",
      color: "white",
      borderRadius: "50%",
      padding: "12px",
      backdropFilter: "blur(8px)",
      "&:hover": {
        backgroundColor: "rgba(255,255,255,0.2)",
      },
    },

    eventTypeIcon: {
      padding: "4px",
      borderRadius: "50%",
      backgroundColor: "#e8f5e9",
      color: "#2e7d32",
      marginRight: "8px",
    },
    dateIcon: {
      padding: "4px",
      borderRadius: "50%",
      backgroundColor: "#e3f2fd",
      color: "#1976d2",
      marginRight: "8px",
    },
    attendButton: {
      marginTop: "16px",
      backgroundColor: "#030553",
      color: "white",
      "&:hover": {
        backgroundColor: "#050870",
      },
    },
    followButton: {
      marginTop: "8px",
      borderColor: "#030553",
      color: "#a0b4ff",
      "&:hover": {
        borderColor: "#050870",
        backgroundColor: "rgba(3,5,83,0.2)",
      },
    },
  };

  const classes = {
    appBar: {
      top: "auto",
      bottom: 0,
      backgroundColor: "#030553",
      color: "white",
    },
    toolbar: {
      justifyContent: "space-around",
    },
    iconButton: {
      display: "flex",
      justifyContent: "center",
      color: "white",
    },
    icon: {
      color: "white",
    },
    avatar: {
      width: 24,
      height: 24,
      border: "2.3px solid rgba(255,255,255,0.5)",
    },
  };

  const additionalStyles = {
    noResults: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "32px",
      textAlign: "center",
      marginTop: 0,
      backgroundColor: brandColors.backgroundPaper,
      borderRadius: "12px",
      boxShadow: "0 2px 12px rgba(0,0,0,0.3)",
      gap: "16px",
    },
    noResultsIcon: {
      fontSize: "48px",
      color: "#9e9e9e",
      marginBottom: "8px",
    },
  };

  const NoResults = () => (
    <Paper sx={additionalStyles.noResults}>
      <EventIcon sx={additionalStyles.noResultsIcon} />
      <Typography variant="h6"><T>No encontramos resultados</T></Typography>
      <Typography color="textSecondary">
        <T>No hay eventos que coincidan con</T> "{searchTerm}"
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          setSearchTerm("");
          setHasSearched(false);
        }}
      >
        <T>Limpiar búsqueda</T>
      </Button>
    </Paper>
  );

  // Muestra los eventos de a 13 y suma otros 13 al acercarse al último.
  const { limit: eventsLimit, sentinelRef: eventsSentinelRef } = useInfiniteScroll(
    JSON.stringify([searchTerm, filterEventType, filterFollowedOnly, filterFreeOnly, filterAttendingOnly, dateRange, sortBy]),
    FEED_PAGE_SIZE
  );

  const eventsToRender = useMemo(() => {
    let eventsToRender = (
      searchTerm.trim() !== "" ? filteredEvents : events
    ).filter((event) => !blockedIds.includes(event.uid) && !hiddenEventIds.includes(event.id));

    // Eventos privados (ver publishEvents.js): solo el dueño y los
    // participantes elegidos los ven en el feed (firestore.rules ya impide
    // leerlos directo si no se cumple esta condición).
    eventsToRender = eventsToRender.filter(
      (event) =>
        !event.isPrivate ||
        event.uid === auth.currentUser?.uid ||
        event.participantIds?.includes(auth.currentUser?.uid)
    );

    if (detectedCountry) {
      // Los eventos "worldwide" se guardan sin country (ver publishEvents.js)
      // y deben verse desde cualquier país.
      eventsToRender = eventsToRender.filter(
        (event) => !event.country || event.country === detectedCountry
      );
    }
    if (filterEventType) {
      eventsToRender = eventsToRender.filter((event) => event.eventType === filterEventType);
    }
    if (filterFollowedOnly) {
      eventsToRender = eventsToRender.filter((event) => following.includes(event.uid));
    }
    if (filterFreeOnly) {
      eventsToRender = eventsToRender.filter((event) => !event.ticketPrice);
    }
    if (filterAttendingOnly) {
      eventsToRender = eventsToRender.filter((event) => attendees[event.id]?.includes(auth.currentUser?.uid));
    }
    // Con varias fechas (ver getEventDates), el evento entra en el rango si
    // alguna de sus fechas cae dentro.
    if (dateRange.from || dateRange.to) {
      const from = dateRange.from ? new Date(dateRange.from) : null;
      const to = dateRange.to ? new Date(dateRange.to) : null;
      eventsToRender = eventsToRender.filter((event) =>
        getEventDates(event).some((d) => (!from || d >= from) && (!to || d <= to))
      );
    }

    const toTime = (value) => (value?.toDate ? value.toDate().getTime() : new Date(value || 0).getTime());
    if (sortBy === "proximos") {
      // Por la próxima función; los eventos que ya terminaron van al final.
      const nextTime = (event) => getNextEventDate(event)?.getTime() ?? Number.MAX_SAFE_INTEGER;
      eventsToRender = [...eventsToRender].sort((a, b) => nextTime(a) - nextTime(b));
    } else if (sortBy === "recientes") {
      eventsToRender = [...eventsToRender].sort((a, b) => toTime(b.createdAt) - toTime(a.createdAt));
    } else if (sortBy === "interesa") {
      eventsToRender = [...eventsToRender].sort((a, b) => (b.likes?.length || 0) - (a.likes?.length || 0));
    }

    // Eventos destacados (beneficio Profesional/Premium, ver publishEvents.js)
    // suben al principio del listado sin alterar el orden relativo del resto.
    eventsToRender = [...eventsToRender].sort((a, b) => (b.featured ? 1 : 0) - (a.featured ? 1 : 0));
    return eventsToRender;
  }, [
    searchTerm,
    filteredEvents,
    events,
    blockedIds,
    hiddenEventIds,
    detectedCountry,
    filterEventType,
    filterFollowedOnly,
    following,
    filterFreeOnly,
    filterAttendingOnly,
    attendees,
    dateRange,
    sortBy,
  ]);

  // Con /events?highlight=<id> el evento tiene que estar renderizado para
  // poder scrollear hasta él aunque quede más allá de la primera tanda.
  const highlightParam = searchParams.get("highlight");
  const highlightIndex = highlightParam ? eventsToRender.findIndex((e) => e.id === highlightParam) : -1;
  const visibleCount = Math.max(eventsLimit, highlightIndex + 1);
  // Si no alcanzan los eventos cargados (filtros, búsqueda o deep link a uno
  // que todavía no llegó), se piden más tandas.
  useEnsureFeedCount(
    eventsFeed,
    eventsToRender.length,
    highlightParam && highlightIndex < 0 ? eventsToRender.length + 1 : visibleCount
  );

  const authorPhotos = useAuthorPhotos(eventsToRender.map((event) => event.uid));

  const renderEventList = useMemo(() => {
    const items = eventsToRender.slice(0, visibleCount).map((event) => (
      <ListItem
        key={event.id}
        id={`event-${event.id}`}
        sx={{
          ...styles.listItem,
          ...feedPostSx,
          transition: "box-shadow 0.3s ease, background-color 0.3s ease",
          ...(highlightedEventId === event.id && {
            boxShadow: `0 0 0 3px ${brandColors.accent}`,
            backgroundColor: alpha(brandColors.accent, 0.08),
            borderRadius: "8px",
          }),
        }}
      >
        <Box sx={{ ...styles.contUser, ...feedPostHeaderSx }}>
          <CardMedia
            component="img"
            image={authorPhotos[event.uid] || event.image}
            title="Perfil"
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              marginRight: 16,
              border: `2.5px solid ${brandColors.divider}`,
            }}
          />
          <Typography
            onClick={() => handleClickPerfil(event)}
            style={styles.name}
          >
            {event.name}
          </Typography>
          {verifiedUids.includes(event.uid) && <VerifiedBadge />}
          {officialUids.includes(event.uid) && <OfficialBadge />}
          {event.featured && (
            <Chip
              icon={<StarIcon sx={{ fontSize: 14 }} />}
              label={<T>Destacado</T>}
              size="small"
              sx={{ ml: 1, height: 22, bgcolor: brandColors.accent, color: '#fff', '& .MuiChip-icon': { color: '#fff' } }}
            />
          )}
          <Box sx={{ flexGrow: 1 }} />
          {!isCompanyFollowed(event.uid) && (
            <Button
              size="small"
              variant="outlined"
              onClick={() => handleFollowCompany(event.uid)}
              disabled={loading}
              sx={{ mr: 1, textTransform: 'none', borderColor: brandColors.primary, color: brandColors.accent }}
            >
              <T>Seguir</T>
            </Button>
          )}
          {!!auth.currentUser && (
            <IconButton
              onClick={() => handleToggleSaveEventClick(event)}
              aria-label={savedEventIds.includes(event.id) ? "quitar de guardados" : "guardar"}
            >
              {savedEventIds.includes(event.id) ? <BookmarkIcon /> : <BookmarkBorderIcon />}
            </IconButton>
          )}
          <FollowItemButton type="event" item={event} />
          <IconButton
            onClick={() => {
              if (navigator.share) {
                navigator.share({
                  title: event.title,
                  text: event.description,
                  url: `${window.location.origin}/profile/${event.uid}`,
                }).catch(() => {});
              }
            }}
            aria-label="share"
          >
            <ShareIcon />
          </IconButton>
          <IconButton
            onClick={(e) => handleOpenOptionsMenu(e, event)}
            aria-label="more options"
          >
            <MoreVertIcon />
          </IconButton>
        </Box>
        <Box sx={feedPostBodySx}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: { xs: "100%", md: "30%" },
              pr: { xs: 0, md: 2 },
              alignItems: { xs: "center", md: "flex-start" },
              mb: { xs: 2, md: 0 },
            }}
          >
            {event.videos && event.videos.length > 0 ? (
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  paddingBottom: aspectRatio === "16:9" ? "56.25%" : "177.78%",
                  backgroundColor: "#000",
                  overflow: "hidden",
                  borderRadius: feedPostMediaRadius,
                }}
              >
                <ScrollAwareVideo
                  src={event.videos[0]}
                  controls
                  playsInline
                  onLoadedMetadata={handleLoadedMetadata}
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                  muted={false}
                />
              </Box>
            ) : event.images && event.images.length > 0 ? (
              <Box sx={{ ...styles.imageContainer, borderRadius: feedPostMediaRadius }}>
                <CardMedia
                  component="img"
                  image={event.images[0]}
                  alt={`Imagen principal de ${event.name}`}
                  style={styles.mainImage}
                />
                {event.images.length > 1 && (
                  <Box
                    style={styles.additionalImagesOverlay}
                    onClick={() => handleOpenImageModal(event.images)}
                  >
                    <Typography style={styles.additionalImagesCount}>
                      +{event.images.length - 1}
                    </Typography>
                    <Typography><T>Ver más</T></Typography>
                  </Box>
                )}
              </Box>
            ) : (
              <Box style={styles.noImage}>
                <Typography><T>No hay medios disponibles</T></Typography>
              </Box>
            )}
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              width: { xs: "100%", md: "70%" },
              px: feedPostTextPx,
            }}
          >
            <Typography component={Link} to={`/events/${event.id}`} style={styles.title} sx={{ color: "inherit", textDecoration: "none", display: "block", "&:hover": { textDecoration: "underline" } }}>{event.title}</Typography>
            {(event.isPrivate || event.isPaid) && (
              <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
                {event.isPrivate && (
                  <Chip
                    size="small"
                    icon={<LockIcon sx={{ fontSize: 16 }} />}
                    label={<T>Privado</T>}
                    sx={{ backgroundColor: alpha(brandColors.accent, 0.15), color: brandColors.accent }}
                  />
                )}
                {event.isPaid && (
                  <Chip
                    size="small"
                    label={`$${Number(event.ticketPrice).toFixed(2)}`}
                    sx={{ backgroundColor: alpha(brandColors.accent, 0.15), color: brandColors.accent }}
                  />
                )}
              </Box>
            )}
            <Typography style={styles.description}>
              {event.description}
            </Typography>
            <Typography style={styles.event}>
              <T>Tipo de evento:</T> {event.eventType}
            </Typography>
            <Typography style={styles.date}>
              {getEventDates(event).length > 1 ? <T>Fechas:</T> : <T>Fecha:</T>} {formatEventDatesList(event)}
            </Typography>
            <EventCountdown event={event} />
            {event.direccion && (
              <Typography style={styles.event}>
                <T>Dirección:</T> {event.direccion}
              </Typography>
            )}
            {event.horario && (
              <Typography style={styles.date}>
                <T>Horario:</T> {getHorarioLabel(event.horario)}
              </Typography>
            )}
            {event.url && (
              <Typography style={{ ...styles.event, overflowWrap: "anywhere" }}>
                <T>Enlace:</T>{" "}
                <a href={safeHttpUrl(event.url) || undefined} target="_blank" rel="noopener noreferrer nofollow" style={{ color: "#a0b4ff" }}>
                  {event.url}
                </a>
              </Typography>
            )}
            {event.url && event.cupon && <CopyToClipboardComponent textToCopy={event.cupon} />}
            <Typography style={styles.created}>
              <T>Fecha de publicación:</T> {formatDate(event.createdAt)}
            </Typography>
            {event.isPaid && !event.paypalEmail && event.url && (
              <Button
                fullWidth
                component="a"
                href={safeHttpUrl(event.url) || undefined}
                target="_blank"
                rel="noopener noreferrer nofollow"
                sx={{
                  backgroundColor: brandColors.action,
                  color: brandColors.onAction,
                  borderColor: brandColors.action,
                  "&:hover": { backgroundColor: brandColors.actionHover },
                  mt: 1,
                }}
              >
                <T>Comprar entrada</T> (${Number(event.ticketPrice).toFixed(2)})
              </Button>
            )}
            {sellsTicketsWithPaypal(event) &&
            event.uid !== auth.currentUser?.uid &&
            !event.ticketBuyers?.includes(auth.currentUser?.uid) ? (
              purchasingEventId === event.id ? (
                <Box sx={{ width: "100%", mt: 1, mb: 1 }}>
                  <PaypalButton
                    amount={event.ticketPrice}
                    currency="USD"
                    description={`Entrada: ${event.title}`}
                    clientId={process.env.REACT_APP_PAYPAL_CLIENT_ID}
                    payeeEmail={event.paypalEmail}
                    metadata={{ customId: event.id }}
                    onApprove={(details) => handleTicketPurchaseApproved(event, details)}
                  />
                  <Button
                    size="small"
                    onClick={() => setPurchasingEventId(null)}
                    sx={{ mt: 1, textTransform: "none" }}
                  >
                    <T>Cancelar</T>
                  </Button>
                </Box>
              ) : (
                <Button
                  fullWidth
                  onClick={() => setPurchasingEventId(event.id)}
                  disabled={loading}
                  sx={{
                    ...styles.actionButton,
                    backgroundColor: brandColors.action,
                    color: brandColors.onAction,
                    borderColor: brandColors.action,
                    '&:hover': { backgroundColor: brandColors.actionHover },
                    mt: 1,
                    mb: 1,
                  }}
                >
                  <T>Comprar entrada</T> (${Number(event.ticketPrice).toFixed(2)})
                </Button>
              )
            ) : (
              <Button
                fullWidth
                onClick={() => handleAttendEvent(event.id)}
                disabled={loading}
                sx={{
                  ...styles.actionButton,
                  backgroundColor: brandColors.action,
                  color: brandColors.onAction,
                  borderColor: brandColors.action,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 1,
                  '&:hover': {
                    backgroundColor: brandColors.primaryHover,
                  },
                  mt: 1,
                  mb: 1
                }}
              >
                {attendees[event.id]?.length > 0 && (
                  <AvatarGroup
                    max={3}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenAttendeesDialog(event.id);
                    }}
                    sx={{
                      '& .MuiAvatar-root': {
                        width: 22,
                        height: 22,
                        fontSize: '0.7rem',
                        border: `1.5px solid ${brandColors.primary}`,
                      },
                    }}
                  >
                    {attendees[event.id].slice(0, 3).map((attendeeId) => (
                      <Avatar
                        key={attendeeId}
                        src={attendeeProfiles[attendeeId]?.profileImageUrl || ""}
                        alt="Avatar"
                      />
                    ))}
                  </AvatarGroup>
                )}
                {event.isPaid && event.ticketBuyers?.includes(auth.currentUser?.uid) && event.uid !== auth.currentUser?.uid
                  ? <T>Ya tenés tu entrada</T>
                  : attendees[event.id]?.includes(auth.currentUser?.uid)
                  ? <T>No asistiré</T>
                  : <T>Asistiré</T>}
                <Box
                  component="span"
                  sx={{
                    ml: 0.75,
                    px: 1,
                    py: 0.25,
                    borderRadius: "999px",
                    fontSize: "0.75rem",
                    fontWeight: 700,
                    lineHeight: 1.6,
                    backgroundColor: "rgba(127,127,127,0.25)",
                  }}
                >
                  {formatCount(attendees[event.id]?.length || 0)}
                </Box>
              </Button>
            )}
            {event.uid === auth.currentUser?.uid && event.isPaid && pendingEventCommissions[event.id]?.amount > 0 && (
              <Box sx={{ width: "100%", mt: 1, mb: 1, p: 1.5, backgroundColor: brandColors.backgroundDefault, borderRadius: "8px" }}>
                <Typography variant="body2" sx={{ color: brandColors.accent, mb: 1 }}>
                  <T>Comisión de Notiline pendiente ({pendingEventCommissions[event.id].salesCount} entrada{pendingEventCommissions[event.id].salesCount !== 1 ? "s" : ""}): ${Number(pendingEventCommissions[event.id].amount).toFixed(2)}</T>
                </Typography>
                {commissionFeedback[event.id] && (
                  <Alert severity={commissionFeedback[event.id].type} sx={{ mb: 1 }}>
                    {commissionFeedback[event.id].message}
                  </Alert>
                )}
                <PaypalButton
                  amount={pendingEventCommissions[event.id].amount}
                  description={`Comisión Notiline - ${event.title}`}
                  clientId={process.env.REACT_APP_PAYPAL_CLIENT_ID}
                  payeeEmail={process.env.REACT_APP_PLATFORM_PAYPAL_EMAIL}
                  metadata={{ customId: event.id }}
                  onApprove={(details) => handleEventCommissionApproved(event, details)}
                />
              </Box>
            )}
            <InterestButton
              liked={!!userLikes[event.id]}
              count={formatCount(event.likes?.length || 0)}
              onClick={() => handleMeInteresaClick(event.id)}
              disabled={loading}
            />
          </Box>
        </Box>

        <Box sx={{ mt: { xs: 2, sm: 3 }, borderTop: `1px solid ${brandColors.divider}`, pt: 2, px: feedPostTextPx, pb: { xs: 1.5, sm: 0 } }}>
          <Box
            onClick={() => setShowEventQA((prev) => ({ ...prev, [event.id]: !prev[event.id] }))}
            sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}
          >
            <ForumOutlinedIcon sx={{ fontSize: 20, color: brandColors.textSecondary }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 600, flexGrow: 1, display: 'flex', alignItems: 'center' }}>
              <T>Preguntas y Respuestas</T>
              {(eventQuestionsAndAnswers[event.id]?.length ?? 0) > 0 && (
                <Box
                  component="span"
                  sx={{ ml: 0.75, px: 1, py: 0.125, borderRadius: '999px', fontSize: '0.75rem', fontWeight: 700, backgroundColor: 'rgba(127,127,127,0.25)' }}
                >
                  {eventQuestionsAndAnswers[event.id].length}
                </Box>
              )}
            </Typography>
            {showEventQA[event.id] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </Box>
          {showEventQA[event.id] && (
            <>
              {!eventQuestionsAndAnswers[event.id]?.length && (
                <Box sx={{ textAlign: 'center', py: 3 }}>
                  <ForumOutlinedIcon sx={{ fontSize: 32, color: brandColors.divider, mb: 1 }} />
                  <Typography variant="body2" sx={{ color: brandColors.textSecondary }}>
                    <T>Todavía no hay preguntas. ¡Sé el primero en preguntar!</T>
                  </Typography>
                </Box>
              )}
              <List dense sx={{ p: 0, mt: 1 }}>
                {eventQuestionsAndAnswers[event.id]?.slice(0, showMoreEventQuestions[event.id] ? undefined : 1).map((item) => (
                  <ListItem key={item.id} alignItems="flex-start" sx={{ p: 0, mb: 1.5 }}>
                    <Paper variant="outlined" sx={{ p: 1.75, width: '100%', borderRadius: 2, bgcolor: brandColors.backgroundPaper, borderColor: brandColors.divider }}>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Avatar src={item.profileImageUrl} alt={item.displayName} sx={{ width: 32, height: 32 }} />
                        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75, flexWrap: 'wrap' }}>
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>{item.displayName}</Typography>
                            {item.createdAt && (
                              <Typography variant="caption" sx={{ color: brandColors.textSecondary }}>
                                {formatDate(item.createdAt)}
                              </Typography>
                            )}
                          </Box>
                          <Typography variant="body2" sx={{ mt: 0.25 }}>{item.question}</Typography>
                        </Box>
                      </Box>
                      {item.answers.map((answer) => (
                        <Box key={answer.id} sx={{ display: 'flex', gap: 1, mt: 1.5, pl: 2, borderLeft: `2px solid ${brandColors.divider}` }}>
                          <Avatar src={answer.profileImageUrl} alt={answer.displayName} sx={{ width: 26, height: 26 }} />
                          <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75, flexWrap: 'wrap' }}>
                              <Typography variant="body2" sx={{ fontWeight: 600, color: brandColors.accent }}>{answer.displayName}</Typography>
                              {answer.createdAt && (
                                <Typography variant="caption" sx={{ color: brandColors.textSecondary }}>
                                  {formatDate(answer.createdAt)}
                                </Typography>
                              )}
                            </Box>
                            <Typography variant="body2" sx={{ mt: 0.25 }}>{answer.answer}</Typography>
                          </Box>
                        </Box>
                      ))}
                      {auth.currentUser?.uid === event.uid && !item.answers.length && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1.5, pl: 2 }}>
                          <TextField
                            fullWidth
                            variant="standard"
                            size="small"
                            placeholder="Escribe tu respuesta..."
                            value={newEventAnswer[item.id] || ""}
                            onChange={(e) => setNewEventAnswer((prev) => ({ ...prev, [item.id]: e.target.value }))}
                          />
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => handleEventAnswerSubmit(item.id, event.id)}
                            disabled={!newEventAnswer[item.id]?.trim()}
                          >
                            <SendIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      )}
                    </Paper>
                  </ListItem>
                ))}
              </List>

              {(eventQuestionsAndAnswers[event.id]?.length ?? 0) > 1 && (
                <Button
                  size="small"
                  onClick={() => setShowMoreEventQuestions((prev) => ({ ...prev, [event.id]: !prev[event.id] }))}
                  sx={{ mt: 0, textTransform: 'none', fontSize: '0.8rem' }}
                >
                  {showMoreEventQuestions[event.id] ? <T>Mostrar menos</T> : <><T>Mostrar</T> {eventQuestionsAndAnswers[event.id].length - 1} <T>más</T></>}
                </Button>
              )}

              {!!auth.currentUser && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1.5 }}>
                  <TextField
                    fullWidth
                    placeholder="Escribe una pregunta..."
                    size="small"
                    value={newEventQuestion[event.id] || ""}
                    onChange={(e) => setNewEventQuestion((prev) => ({ ...prev, [event.id]: e.target.value }))}
                    sx={{
                      '& .MuiOutlinedInput-root': { borderRadius: '999px', bgcolor: brandColors.inputBackground },
                      '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                    }}
                  />
                  <IconButton
                    onClick={() => handleEventQuestionSubmit(event.id)}
                    disabled={!newEventQuestion[event.id]?.trim()}
                    sx={{
                      bgcolor: brandColors.primary,
                      color: '#fff',
                      '&:hover': { bgcolor: brandColors.primaryHover },
                      '&.Mui-disabled': { bgcolor: 'rgba(127,127,127,0.25)', color: brandColors.textSecondary },
                    }}
                  >
                    <SendIcon fontSize="small" />
                  </IconButton>
                </Box>
              )}
            </>
          )}
        </Box>
      </ListItem>
    ));
    if (eventsToRender.length > visibleCount || !eventsFeed.exhausted) {
      items.push(<Box key="events-sentinel" ref={eventsSentinelRef} sx={{ height: 1 }} />);
    }
    return items;
  }, [
    eventsToRender,
    authorPhotos,
    visibleCount,
    eventsFeed.exhausted,
    eventsSentinelRef,
    aspectRatio,
    filteredEvents,
    events,
    searchTerm,
    attendees,
    attendeeProfiles,
    handleAttendEvent,
    handleFollowCompany,
    isCompanyFollowed,
    handleClickPerfil,
    handleOpenImageModal,
    blockedIds,
    handleOpenOptionsMenu,
    filterEventType,
    filterFollowedOnly,
    filterFreeOnly,
    filterAttendingOnly,
    dateRange,
    sortBy,
    following,
    userLikes,
    detectedCountry,
    eventQuestionsAndAnswers,
    showMoreEventQuestions,
    showEventQA,
    newEventQuestion,
    newEventAnswer,
    savedEventIds,
    hiddenEventIds,
    handleToggleSaveEventClick,
    purchasingEventId,
    pendingEventCommissions,
    commissionFeedback,
    handleTicketPurchaseApproved,
    handleEventCommissionApproved,
    highlightedEventId,
  ]);

  const SkeletonEventCard = () => (
    <ListItem sx={{ ...styles.listItem, ...feedPostSx }}>
      <Box sx={{ ...styles.contUser, ...feedPostHeaderSx }}>
        <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
        <Skeleton variant="text" width="40%" height={24} />
        <Box sx={{ flexGrow: 1 }} />
        <Skeleton variant="circular" width={32} height={32} />
      </Box>

      <Box sx={feedPostBodySx}>
        <Box sx={{ width: { xs: "100%", md: "30%" }, pr: { xs: 0, md: 2 } }}>
          <Skeleton 
            variant="rectangular" 
            width="100%" 
            sx={{ 
              paddingBottom: '56.25%',
              borderRadius: feedPostMediaRadius,
              mb: 1 
            }} 
          />
        </Box>

        <Box sx={{ width: { xs: "100%", md: "70%" }, px: feedPostTextPx, pb: { xs: 1.5, sm: 0 } }}>
          <Skeleton variant="text" width="80%" height={28} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="100%" height={20} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width="90%" height={20} sx={{ mb: 1 }} />
          <Skeleton variant="rectangular" width="40%" height={24} sx={{ borderRadius: '4px', mb: 1 }} />
          <Skeleton variant="rectangular" width="50%" height={24} sx={{ borderRadius: '4px', mb: 1 }} />
          <Skeleton variant="text" width="60%" height={16} sx={{ mb: 2 }} />
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Skeleton variant="rectangular" width="100%" height={36} sx={{ borderRadius: '6px', mb: 1 }} />
          </Box>
          <Skeleton variant="rectangular" width="100%" height={36} sx={{ borderRadius: '6px' }} />
        </Box>
      </Box>
    </ListItem>
  );

  const SkeletonLoader = () => (
    <Container maxWidth={false} disableGutters sx={pageContentSx}>
      {[1, 2, 3].map((index) => (
        <SkeletonEventCard key={index} />
      ))}
    </Container>
  );

  const handleClearFilters = () => {
    setSortBy("proximos");
    setFilterEventType("");
    setFilterFollowedOnly(false);
    setFilterFreeOnly(false);
    setFilterAttendingOnly(false);
    setDateRange({ from: "", to: "" });
  };

  const hasActiveFilters = Boolean(
    searchTerm.trim() || filterEventType || filterFollowedOnly || filterFreeOnly || filterAttendingOnly ||
    dateRange.from || dateRange.to
  );

  const filtersFields = (
    <>
      <Typography variant="caption" sx={{ color: "text.secondary" }}><T>Ordenar por</T></Typography>
      <FormControl fullWidth sx={{ mb: 3 }}>
        <Select
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
        >
          <MenuItem value="proximos"><T>Próximos primero</T></MenuItem>
          <MenuItem value="recientes"><T>Más recientes</T></MenuItem>
          <MenuItem value="interesa"><T>Más "Me interesa"</T></MenuItem>
        </Select>
      </FormControl>

      <Typography variant="caption" sx={{ color: "text.secondary" }}><T>Tipo de evento</T></Typography>
      <FormControl fullWidth sx={{ mb: 3 }}>
        <Select
          displayEmpty
          value={filterEventType}
          onChange={(e) => setFilterEventType(e.target.value)}
        >
          <MenuItem value=""><T>Todos</T></MenuItem>
          <MenuItem value="exposicion"><T>Exposición</T></MenuItem>
          <MenuItem value="innauguracion"><T>Innauguración</T></MenuItem>
          <MenuItem value="feriado"><T>Feriado</T></MenuItem>
          <MenuItem value="concierto"><T>Concierto</T></MenuItem>
          <MenuItem value="festival"><T>Festival</T></MenuItem>
          <MenuItem value="obraDeTeatro"><T>Obra de teatro</T></MenuItem>
          <MenuItem value="conferencia"><T>Conferencia</T></MenuItem>
          <MenuItem value="otro"><T>Otro</T></MenuItem>
        </Select>
      </FormControl>

      <FormControlLabel
        sx={{ display: "flex", mb: 0.5 }}
        control={<Checkbox checked={filterFollowedOnly} onChange={(e) => setFilterFollowedOnly(e.target.checked)} />}
        label={<T>Solo empresas que sigo</T>}
      />
      <FormControlLabel
        sx={{ display: "flex", mb: 0.5 }}
        control={<Checkbox checked={filterFreeOnly} onChange={(e) => setFilterFreeOnly(e.target.checked)} />}
        label={<T>Solo eventos gratuitos</T>}
      />
      <FormControlLabel
        sx={{ display: "flex", mb: 2 }}
        control={<Checkbox checked={filterAttendingOnly} onChange={(e) => setFilterAttendingOnly(e.target.checked)} />}
        label={<T>Solo a los que asistiré</T>}
      />

      <Typography sx={{ mb: 1 }}><T>Rango de fechas</T></Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box sx={{ flex: 1 }}>
          <Typography variant="caption" sx={{ color: "text.secondary" }}><T>Desde</T></Typography>
          <TextField
            type="date"
            size="small"
            fullWidth
            value={dateRange.from}
            onChange={(e) => setDateRange((prev) => ({ ...prev, from: e.target.value }))}
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography variant="caption" sx={{ color: "text.secondary" }}><T>Hasta</T></Typography>
          <TextField
            type="date"
            size="small"
            fullWidth
            value={dateRange.to}
            onChange={(e) => setDateRange((prev) => ({ ...prev, to: e.target.value }))}
          />
        </Box>
      </Box>

      <Button
        fullWidth
        size="small"
        onClick={handleClearFilters}
        sx={{ mt: 3, textTransform: 'none' }}
      >
        <T>Limpiar filtros</T>
      </Button>
    </>
  );

  const renderContent = () => {
    // Sin resultados todavía pero quedan tandas por traer: se sigue buscando.
    if (eventsToRender.length === 0 && feedMayHaveMore(eventsFeed)) {
      return <SkeletonLoader />;
    }

    if (hasSearched && filteredEvents.length === 0) {
      return <NoResults />;
    }

    if (!hasSearched && events.length === 0) {
      return (
        <Paper sx={additionalStyles.noResults}>
          <EventIcon sx={additionalStyles.noResultsIcon} />
          <Typography variant="h6"><T>Aún no hay publicaciones</T></Typography>
          <Typography color="textSecondary">
            <T>Vuelve más tarde o sé el primero en publicar algo.</T>
          </Typography>
        </Paper>
      );
    }

    if (!hasSearched && events.length > 0 && renderEventList.length === 0) {
      return (
        <Paper sx={additionalStyles.noResults}>
          <EventIcon sx={additionalStyles.noResultsIcon} />
          <Typography variant="h6"><T>No hay coincidencias</T></Typography>
          <Typography color="textSecondary">
            <T>No encontramos eventos con los filtros seleccionados.</T>
          </Typography>
          <Button variant="contained" color="primary" onClick={handleClearFilters}>
            <T>Limpiar filtros</T>
          </Button>
        </Paper>
      );
    }

    return renderEventList;
  };

  return (
    <Container maxWidth={false} disableGutters>
      <BottomToolbar />

      {showTopBar && (

      <AppBar ref={appBarRef} position="fixed" elevation={0} sx={styles.topAppBar}>
        {!sidebarActive && (
        <Toolbar sx={styles.logoToolbar}>
          <CardMedia
            component="img"
            image={isDarkTheme ? DARK_LOGO_URL : isLightTheme ? LIGHT_LOGO_URL : logoSvg}
            title="Notiline"
            style={styles.media}
          />
        </Toolbar>
        )}
        <CustomToolbar
          isSearchOpen={isSearchOpen}
          onToggleSearch={toggleSearch}
          onOpenFilters={() => setFiltersOpen(true)}
          showSearchFilters={!isDesktop}
        />
        {!isDesktop && isSearchOpen && (
          <Box
            sx={{
              backgroundColor: sidebarActive ? "transparent" : barColors.background,
              px: 2,
              py: searchBarHidden ? 0 : 1,
              maxHeight: searchBarHidden ? 0 : 96,
              opacity: searchBarHidden ? 0 : 1,
              overflow: "hidden",
              transition: "max-height 0.28s ease, opacity 0.2s ease, padding 0.28s ease",
            }}
          >
            <Box sx={{ ...pageContentSx, display: "flex", alignItems: "center", gap: 1 }}>
              <TextField
                id="search-input"
                fullWidth
                autoFocus
                size="small"
                placeholder="Buscar evento"
                value={searchTerm}
                onChange={handleSearchChange}
                autoComplete="off"
                InputProps={{
                  endAdornment: <SearchClearAdornment value={searchTerm} onChange={handleSearchChange} />,
                  startAdornment: <SearchIcon sx={{ mr: 1, color: brandColors.textSecondary }} />,
                  sx: {
                    color: brandColors.textPrimary,
                    backgroundColor: brandColors.inputBackground,
                    borderRadius: "999px",
                    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                    "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
                  },
                }}
              />
            </Box>
          </Box>
        )}
      </AppBar>

      )}
      <Container maxWidth={false} disableGutters sx={{ width: "100%", mt: `${appBarHeight}px`, mb: 10 }}>
        {!isDesktop && (
          <Drawer
            anchor="bottom"
            open={filtersOpen}
            onClose={() => setFiltersOpen(false)}
            PaperProps={{ sx: { borderTopLeftRadius: 16, borderTopRightRadius: 16, maxHeight: "85vh", overflowX: "hidden" } }}
          >
            <Box sx={{ pt: 1.5, pb: 4, px: 3, width: "100%", maxWidth: `${PAGE_CONTENT_MAX_WIDTH}px`, mx: "auto", boxSizing: "border-box" }}>
              <SheetDragHandle onClose={() => setFiltersOpen(false)} />
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}><T>Filtros</T></Typography>
                <IconButton onClick={() => setFiltersOpen(false)} size="small">
                  <CloseIcon />
                </IconButton>
              </Box>
              {filtersFields}
            </Box>
          </Drawer>
        )}
        <Box
          sx={{
            display: isDesktop ? "grid" : "block",
            gridTemplateColumns: isDesktop ? "260px 980px 260px" : undefined,
            columnGap: isDesktop ? 3 : 0,
            width: "100%",
            maxWidth: isDesktop ? "1568px" : `${PAGE_CONTENT_MAX_WIDTH}px`,
            mx: "auto",
            pt: isDesktop ? "20px" : 0,
            px: 2,
            boxSizing: "border-box",
          }}
        >
          {isDesktop && (
            <Paper
              variant="outlined"
              sx={{ p: 2.5, borderRadius: 3, position: "sticky", top: appBarHeight + 16, alignSelf: "start", maxHeight: `calc(100vh - ${appBarHeight + 16 + FILTER_PANEL_BOTTOM_GAP}px)`, ...filterPanelScrollSx }}
            >
              <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}><T>Filtros</T></Typography>
              <TextField
                fullWidth
                size="small"
                placeholder="Buscar evento"
                value={searchTerm}
                onChange={handleSearchChange}
                autoComplete="off"
                sx={{ mb: 3 }}
                InputProps={{
                  endAdornment: <SearchClearAdornment value={searchTerm} onChange={handleSearchChange} />,
                  startAdornment: <SearchIcon sx={{ mr: 1, color: brandColors.textSecondary }} />,
                }}
              />
              {filtersFields}
            </Paper>
          )}
          <Box sx={{ minWidth: 0, pt: isDesktop ? 0 : 2 }}>
            {hasActiveFilters && (
              <Typography variant="h4" align="center" sx={{ mb: 4, fontWeight: "bold", color: "text.primary" }}>
                <T>Resultados</T>
              </Typography>
            )}
            {renderContent()}
            {!eventsFeed.loading && renderEventList.length > 0 && (
              <Typography
                variant="caption"
                align="center"
                sx={{ display: "block", color: brandColors.textSecondary, mt: 4, mb: 10 }}
              >
                © 2026 Dapur Tecnología - Notiline
              </Typography>
            )}
          </Box>
          {isDesktop && <Box />}
        </Box>
        <Dialog
          open={openImageModal}
          onClose={handleCloseImageModal}
          aria-labelledby="image-modal-title"
          aria-describedby="image-modal-description"
          fullScreen
        >
          <DialogTitle id="image-modal-title"><T>Imágenes del Evento</T></DialogTitle>
          <DialogContent>
            <DialogContentText id="image-modal-description">
              {openImageModal && (
                <Box style={styles.imageModalContent}>
                  {modalImages && modalImages.length > 0 ? (
                    <CardMedia
                      component="img"
                      image={modalImages[currentImageIndex]}
                      alt={`Imagen ${currentImageIndex + 1} del alojamiento`}
                      style={styles.imageModalImage}
                    />
                  ) : (
                    <Typography><T>No hay imágenes disponibles</T></Typography>
                  )}
                  <Box style={styles.imageModalNavigation}>
                    <IconButton onClick={handlePreviousImage}>
                      <ArrowBackIosIcon />
                    </IconButton>
                    <IconButton onClick={handleNextImage}>
                      <ArrowForwardIosIcon />
                    </IconButton>
                  </Box>
                </Box>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseImageModal}><T>Cerrar</T></Button>
          </DialogActions>
        </Dialog>
        <AttendeesDialog
          open={openAttendeesDialog}
          onClose={handleCloseAttendeesDialog}
          attendees={selectedEventId ? attendees[selectedEventId] : []}
          userProfiles={userProfiles}
          loading={isLoadingAttendees}
        />
        <Menu
          anchorEl={optionsMenuAnchorEl}
          open={Boolean(optionsMenuAnchorEl)}
          onClose={handleOptionsMenuClose}
        >
          {optionsMenuEvent && isCompanyFollowed(optionsMenuEvent.uid) && (
            <MenuItem
              onClick={() => {
                handleUnfollowMenuClick(optionsMenuEvent);
                handleOptionsMenuClose();
              }}
            >
              <T>Dejar de seguir</T>
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              handleReportEvent(optionsMenuEvent);
              handleOptionsMenuClose();
            }}
          >
            <T>Reportar</T>
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleHideEvent(optionsMenuEvent);
              handleOptionsMenuClose();
            }}
          >
            <T>No me interesa</T>
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleSimilarEvents(optionsMenuEvent);
              handleOptionsMenuClose();
            }}
          >
            <T>Más eventos similares</T>
          </MenuItem>
          {optionsMenuEvent && optionsMenuEvent.uid !== auth.currentUser?.uid && (
            blockedIds.includes(optionsMenuEvent.uid) ? (
              <MenuItem
                onClick={() => {
                  handleUnblockUserClick(optionsMenuEvent);
                  handleOptionsMenuClose();
                }}
              >
                <T>Desbloquear</T>
              </MenuItem>
            ) : (
              <MenuItem
                onClick={() => {
                  handleBlockUserClick(optionsMenuEvent);
                  handleOptionsMenuClose();
                }}
              >
                <T>Bloquear</T>
              </MenuItem>
            )
          )}
        </Menu>
      </Container>
    </Container>
  );
};

export default Events;